<template>
	<div class="container-fluid conteudo">
		<div>
			<div class="fl-cabecalho" v-if="!isModal">
				<div class="row">
					<div class="col-lg-4 col-xs-12">
						<i class="icon icon-administracao_cargos"></i>
						<h3>
							{{ _traducao('global', 'cadastrar') | upper }}
							{{ _traducao('global', 'manobra') | upper }}
						</h3>
						<h4 @click="_exibeSub('ad')" style="cursor: pointer">
							{{ _traducao('menu', 'menuAdministracao').toUpperCase() }}
							{{ _traducao('menu', 'menuGeral').toUpperCase() }}
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</h4>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<div class="text-center" v-show="load">
						<flCarregando />
					</div>
				</div>
			</div>
			<div class="row" v-show="!load" style="margin-top: 20px">
				<div class="col-xs-6">
					<div class="row">
						<div class="col-md-8">
							<i
								class="fa fa-search icone-busca"
								style="top: 8px"
								aria-hidden="true"
							></i>
							<input
								type="text"
								style="padding-left: 25px"
								:placeholder="_traducao('global', 'buscar')"
								@keyup="filtra()"
								v-model="tabela.busca"
								class="form-control"
							/>
						</div>

						<div class="col-xs-4">
							<button
								type="button"
								@click="exibirNovo"
								class="btn btn-block pull-right btn-default"
							>
								<i
									class="icon-solicitacao_nova_solicitacao"
									style="margin-top: 1px; margin-right: 3px; float: left"
								></i>
								{{ _traducao('global', 'novo') }}
							</button>
						</div>
					</div>
					<div class="row" style="margin-top: 8px">
						<div class="col-xs-12">
							<table class="table table-lista table-striped table-hover">
								<thead>
									<tr>
										<th style="width: 70%">
											{{ _traducao('global', 'manobra') }}
										</th>
										<th class="text-center">
											{{ _traducao('global', 'desativar') }} /
											{{ _traducao('global', 'reativar') }}
										</th>
										<th class="text-center">
											{{ _traducao('global', 'editar') }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in tabela.listaChunk[
											tabela.pagination.currentPage - 1
										]"
										:key="index"
									>
										<td>{{ item.descricao }}</td>
										<td class="text-center">
											<a
												v-if="Number(item.inativo) == 0"
												href="#"
												@click.prevent="desativar(item)"
												style="margin-left: 6px; margin-right: 6px"
												v-tooltip="_traducao('global', 'desativar')"
											>
												<i
													class="fa icon-lixeira icone-tabela-pointer"
													style="font-size: 20px"
												></i>
											</a>
											<a
												v-else
												href="#"
												@click.prevent="reativar(item)"
												style="margin-left: 6px; margin-right: 6px"
												v-tooltip="_traducao('global', 'reativar')"
											>
												<i
													class="fa icon-solicitacao_atualizar_status"
													style="font-size: 20px"
												></i>
											</a>
										</td>
										<td class="text-center">
											<a
												href="#"
												@click.prevent="editar(item)"
												style="margin-left: 6px; margin-right: 6px"
											>
												<i class="fa icon-editar" style="font-size: 20px"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 text-center">
							<nav>
								<ul
									class="pagination"
									:class="{'pagination-sm': !_isMobile}"
									style="margin: 0px"
								>
									<li :class="{disabled: tabela.pagination.currentPage == 1}">
										<a href="#" @click.prevent="previous">
											<span aria-hidden="true">
												<i class="fa fa-angle-left" aria-hidden="true"></i>
											</span>
										</a>
									</li>
									<li
										v-for="(item, idxPg) in tabela.pagination.pageNumbers"
										:key="idxPg"
										:class="{active: item == tabela.pagination.currentPage}"
									>
										<a href="#" @click.prevent="page(item)">{{ item }}</a>
									</li>
									<li
										:class="{
											disabled:
												tabela.pagination.currentPage ==
												tabela.pagination.totalPages
										}"
									>
										<a href="#" @click.prevent="next">
											<span aria-hidden="true"
												><i class="fa fa-angle-right" aria-hidden="true"></i
											></span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
				<div class="col-xs-6" v-show="exibirForm">
					<div class="row">
						<div class="col-xs-6" style="color: #555; font-size: 14px">
							<h3 v-show="form.id.model != 0" style="margin: 0px">
								<i
									class="icon icon-solicitacao_editar_solicitacao"
									style="margin-top: 1px; float: left; margin-right: 7px"
								></i>
								{{ _traducao('global', 'editar') }}
							</h3>
							<h3 v-show="form.id.model == 0" style="margin: 0px">
								<i
									class="icon icon-solicitacao_nova_solicitacao"
									style="margin-top: 1px; float: left; margin-right: 7px"
								></i>
								{{ _traducao('global', 'novo') }}
							</h3>
						</div>
						<div class="col-xs-6">
							<button
								type="button"
								@click="clickFecharForm"
								class="btn pull-right btn-xs btn-default"
							>
								<i class="fa fa-times"></i> {{ _traducao('global', 'fechar') }}
							</button>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<hr style="margin-top: 2px; margin-bottom: 10px" />
						</div>
					</div>
					<div class="row">
						<input-model-text
							class="col-xs-12 form-group"
							:label="_traducao('global', 'descricao')"
							v-model="form.descricao"
						/>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<span class="label label-info pull-left no-print">
								<i class="fa fa-info-circle"></i>
								{{ _traducao('global', 'obrigatorio') }}
							</span>
							<button
								type="button"
								@click="salvar"
								class="btn btn-success pull-right"
							>
								<i class="fa fa-check" aria-hidden="true"></i>
								{{ _traducao('global', 'salvar').toUpperCase() }}
							</button>
						</div>
					</div>
				</div>
				<div class="col-xs-6" v-show="!exibirForm">
					<h3 class="text-center">
						<i class="fa fa-info-circle"></i>
						{{ _traducao('menuAGnovoOrgao', 'menuAGtextoG1') }} <br /><br />
						{{ _traducao('global', 'ou') }} <br /><br />
						{{ _traducao('menuAGnovoOrgao', 'menuAGtextoG2') }}
						<i class="fa icon-editar"></i>
						{{ _traducao('menuAGnovoOrgao', 'menuAGtextoG3') }}
					</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $tabela from '../../../../mixins/tabela.js'
import Manobra from '@/models/Manobra.js'
export default {
	mixins: [$tabela],
	props: {
		isModal: {
			type: Boolean
		}
	},
	data() {
		const manobra = new Manobra()
		return {
			manobra,
			load: false,
			exibirForm: false,
			form: manobra.atributos,
			tabela: {
				lista: [],
				listaChunk: [],
				columns: ['id', 'descricao'],
				inverse: 'asc',
				busca: '',
				bouse: false,
				pagination: {
					currentPage: 1,
					totalPages: 0,
					totalItens: 0,
					pageNumbers: [],
					perPage: 10
				}
			}
		}
	},
	mounted() {
		this.getLista()
	},
	methods: {
		clickFecharForm() {
			this.exibirForm = false
		},
		exibirNovo() {
			this.exibirForm = true
			this.limpaForm()
		},
		limpaForm() {
			this.manobra.limpaForm(this.form)
		},
		editar(dados) {
			this.limpaForm()
			this.exibirForm = true
			this.form.id.model = dados.id
			this.form.descricao.model = dados.descricao
		},
		async salvar() {
			const result = await this.manobra.salvar()
			if (result !== false) {
				this.exibirForm = false
				bus.$emit('exibir-notificacao', {
					type: 'success',
					text: this._traducao('global', 'salvoComSucesso')
				})
				await this.getLista()
			}
		},
		async desativar(item) {
			const result = await this.manobra.desativar(item.id)
			if (result !== false) {
				bus.$emit('exibir-notificacao', {
					type: 'success',
					text: this._traducao('global', 'desativadoComSucesso')
				})
				await this.getLista()
			}
		},
		async reativar(item) {
			const result = await this.manobra.reativar(item.id)
			if (result !== false) {
				bus.$emit('exibir-notificacao', {
					type: 'success',
					text: this._traducao('global', 'reativadoComSucesso')
				})
				await this.getLista()
			}
		},
		async getLista() {
			this.$emit('carrega-lista')
			this.limpaForm()
			this.load = true
			const retorno = await this.manobra.all()
			this.tabela.lista = retorno.lista
			this.filtraCore()
			this.load = false
		}
	}
}
</script>